import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37b86ad5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=37b86ad5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b86ad5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b86ad5')) {
      api.createRecord('37b86ad5', component.options)
    } else {
      api.reload('37b86ad5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37b86ad5&scoped=true", function () {
      api.rerender('37b86ad5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/commission/index.vue"
export default component.exports